import { FormikHelpers } from "formik";
import { useGetLine } from "./api/getLine";
import { useEditLine } from "./api/editLine";
import EditLineForm from "./EditLineForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useState } from "react";
import DataLineBillingReport from "./DataLineBillingReport";


const EditLine = ({handleCloseModal, lineId}: EditLineProps)  => {
  const [isBillingReportModalVisible, setIsBillinReportgModalVisible] = useState(false);

  const handleBillingReportButtonClick = () => {
    setIsBillinReportgModalVisible(true); 
  };

  const handleCloseBillingReportModal = () => {
    setIsBillinReportgModalVisible(false); 
  };
  
  const getLineQuery = useGetLine({lineId: lineId})
  const editLineMutation = useEditLine({data: {}, lineId});


  const initialValues: IEditLineForm = {
    applProtocolNumber: getLineQuery.data?.applProtocolNumber ? getLineQuery.data?.applProtocolNumber : "",
    applDate: getLineQuery.data?.applDate ? new Date(getLineQuery.data.applDate) : null,
    offApplDate: getLineQuery.data?.offApplDate ? new Date(getLineQuery.data.offApplDate) : null,
    deliveryDate: getLineQuery.data?.deliveryDate ? new Date(getLineQuery.data.deliveryDate) : null,
    pendingStatusID: getLineQuery.data?.pendingStatusID ? getLineQuery.data.pendingStatusID.toString() : "",
    lineTypeID: getLineQuery.data?.lineTypeID ? getLineQuery.data.lineTypeID.toString() : "",
    providerID: getLineQuery.data?.providerID ? getLineQuery.data.providerID.toString() : "",
    usedByID: getLineQuery.data?.usedByID ? getLineQuery.data.usedByID.toString() : "",
    comments: getLineQuery.data?.comments ? getLineQuery.data.comments : "",
    sapCode: getLineQuery.data?.sapCode ? getLineQuery.data.sapCode : "",
    isEmporiki: getLineQuery.data?.isEmporiki ? getLineQuery.data.isEmporiki : false,
    isCiti: getLineQuery.data?.isCiti ? getLineQuery.data.isCiti : false,
    costByID: getLineQuery.data?.costByID ? getLineQuery.data.costByID.toString() : "",
    speedID: getLineQuery.data?.speedID ? getLineQuery.data.speedID.toString() : "",
    cost: getLineQuery.data?.cost ? getLineQuery.data.cost.toString() : "",
    hcNmsNum: getLineQuery.data?.hcNmsNum ? getLineQuery.data.hcNmsNum : "",
    hcNum1: getLineQuery.data?.hcNum1 ? getLineQuery.data.hcNum1 : "",
    hcNum2: getLineQuery.data?.hcNum2 ? getLineQuery.data.hcNum2 : "",
    accNum1: getLineQuery.data?.accNum1 ? getLineQuery.data.accNum1 : "",
    accNum2: getLineQuery.data?.accNum2 ? getLineQuery.data.accNum2 : "",
    coupleNumA1: getLineQuery.data?.coupleNumA1 ? getLineQuery.data.coupleNumA1 : "",
    coupleNumB1: getLineQuery.data?.coupleNumB1 ? getLineQuery.data.coupleNumB1 : "",
    coupleNumA2: getLineQuery.data?.coupleNumA2 ? getLineQuery.data.coupleNumA2 : "",
    coupleNumB2: getLineQuery.data?.coupleNumB2 ? getLineQuery.data.coupleNumB2 : "",
    phoneNumber: getLineQuery.data?.phoneNumber ? getLineQuery.data.phoneNumber : "",
    descline: getLineQuery.data?.descline ? getLineQuery.data.descline : "",
    endAAddress: getLineQuery.data?.endAAddress ? getLineQuery.data.endAAddress : "",
    endBAddress: getLineQuery.data?.endBAddress ? getLineQuery.data.endBAddress : "",
    removalDate: getLineQuery.data?.removalDate ? new Date(getLineQuery.data.removalDate) : null,
    CDLineType: getLineQuery.data?.CDLineType ? getLineQuery.data.CDLineType : "",
    CDAddressA: getLineQuery.data?.CDAddressA ? getLineQuery.data.CDAddressA : "",
    CDAddressB: getLineQuery.data?.CDAddressB ? getLineQuery.data.CDAddressB : "",
    removalComment: getLineQuery.data?.removalComment ? getLineQuery.data.removalComment : "",
    endAUnitID: getLineQuery.data?.endAUnitID ? getLineQuery.data.endAUnitID.toString() : "",
    endAUnitType: getLineQuery.data?.endAUnitType ? getLineQuery.data.endAUnitType : "",
    endBUnitID: getLineQuery.data?.endBUnitID ? getLineQuery.data.endBUnitID.toString() : "",
    endBUnitType: getLineQuery.data?.endBUnitType ? getLineQuery.data.endBUnitType.toString() : ""
  };

  const handleSubmit = async (values: IEditLineForm, { setSubmitting }: FormikHelpers<IEditLineForm>): Promise<void> => {
    try {
      await editLineMutation.mutateAsync({
        data: values,
        lineId: lineId
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  if (getLineQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getLineQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Γραμμής Data.</div>
    )
  }

  return (
    <>
      {getLineQuery.data &&
         <EditLineForm initialValues={initialValues} onSubmit={handleSubmit} onBillingButtonClick={handleBillingReportButtonClick} isBillingModalActive={isBillingReportModalVisible} /> 
      }

      {isBillingReportModalVisible &&
          <DataLineBillingReport handleCloseModal={handleCloseBillingReportModal} dataLineID={lineId}   />
      }
    </>
  )
}

interface EditLineProps {
  lineId: number;
  handleCloseModal: () => void;
}

export default EditLine;